import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
];

export function LanguageSelector({ variant = 'icon' }) {
  const { i18n } = useTranslation();
  
  const currentLanguage = languages.find(l => i18n.language?.startsWith(l.code)) || languages[0];
  
  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  if (variant === 'menu-item') {
    // For use inside another dropdown menu
    return (
      <>
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={i18n.language?.startsWith(lang.code) ? 'bg-slate-100' : ''}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
            {i18n.language?.startsWith(lang.code) && (
              <span className="ml-auto text-[#0F766E]">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="text-slate-600" data-testid="language-selector">
          <Globe className="w-5 h-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((lang) => (
          <DropdownMenuItem
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={i18n.language?.startsWith(lang.code) ? 'bg-slate-100' : ''}
            data-testid={`lang-${lang.code}`}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
            {i18n.language?.startsWith(lang.code) && (
              <span className="ml-auto text-[#0F766E]">✓</span>
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageSelector;
